module.exports = __webpack_public_path__ + "img/banner1.3391bcf6.jpg";